// extracted by mini-css-extract-plugin
export default {"form":"weatherForm_form__2lqiz"};